import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UserTable from '../../common/UserTable';
import MarketersState from './MarketersState';
import { useNavigate } from 'react-router-dom';
import { IUser } from '../../../interfaces/user.ts';
import { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import BasicModal from '../../common/BasicModal.tsx';
import axios from 'axios';
import IResponse from '../../../interfaces/response.ts';

const Marketers = () => {
	const { t } = useTranslation();
	const [deleteUser, setDeleteUser] = useState<IUser>();
	const [deleteLoading, setDeleteLoading] = useState(false);

	const headerClassNames = 'text-xs bg-background-paper';

	let navigate = useNavigate();
	let tabItem = [
		{
			title: t(`manage_pages`),
			api: '/admin/admins',
			postApi: '/admin/admins/delete',
			role_id: 2,
			view: true,
			edit: true,
			delete: true,
			viewAction: (id: number) => {
				navigate(`/admin/marketers/${id}/edit`);
			},
			editAction: (id: number) => {
				navigate(`/admin/marketers/${id}/edit`);
			},
			columns: [
				{ field: 'name', flex: 1, headerName: t('name'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{ field: 'email', flex: 1, headerName: t('email'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{
					field: 'created_at',
					flex: 1,
					headerName: t('created_time'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						return new Date(params.row.created_at).toLocaleDateString('fa-IR');
					},
				},
				{
					field: 'status',
					headerName: t('status'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						return <div className={`rounded-lg p-2.5 ${params.row.status === 1 ? 'bg-green-50 text-green-600' : 'bg-red-100 text-red-600'}`}>{params.row.status === 1 ? t('active') : t('inactive')}</div>;
					},
				},
			],
			route: 'admin/admin',
		},
	];

	const handleCloseDeleteDialog = () => {
		setDeleteUser(undefined);
	};

	const handleDeleteUser = () => {
		setDeleteLoading(true);
		axios<IResponse<any>>({
			url: `/admin/users/${deleteUser?.id}`,
			method: 'DELETE',
		})
			.then(res => {
				if (res.data.success) {
					setDeleteUser(undefined);
				}
			})
			.finally(() => {
				setDeleteLoading(false);
			});
	};

	return (
		<Box className="w-full">
			<BasicModal
				open={!!deleteUser}
				onClose={handleCloseDeleteDialog}
				title={t('delete_role')}
				titleClassName={'text-center grow '}
				subClassName={'flex flex-row-reverse'}
				className={'max-w-sm rounded-lg'}
				showBackIcon={false}
				action={
					<>
						<Button onClick={handleCloseDeleteDialog} color="inherit">
							{t('cancel')}
						</Button>
						<LoadingButton loading={deleteLoading} onClick={handleDeleteUser} variant="outlined" color="error">
							{t('delete')}
						</LoadingButton>
					</>
				}
			>
				<Typography>{t('delete_user_description', { user: deleteUser?.name })}</Typography>
			</BasicModal>

			<div className="mb-5">
				<MarketersState />
			</div>
			<div>
				<UserTable activeItem={t(`marketers`)} tabItem={tabItem[0]} />
			</div>
		</Box>
	);
};

export default Marketers;
